import { LAMBDATEST_PROMO_BANNER_HEIGHT } from '../constants/setting';

export const setPromoBannerHeight = (height) => {
  return {
    type: LAMBDATEST_PROMO_BANNER_HEIGHT,
    payload: height,
  };
};
